var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateStructure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.456 15.454C15.6033 15.454 14.912 16.1453 14.912 16.998C14.912 17.8507 15.6033 18.542 16.456 18.542C17.3087 18.542 18 17.8507 18 16.998C18 16.1453 17.3087 15.454 16.456 15.454ZM12.912 16.998C12.912 15.0407 14.4987 13.454 16.456 13.454C18.4133 13.454 20 15.0407 20 16.998C20 18.9553 18.4133 20.542 16.456 20.542C14.4987 20.542 12.912 18.9553 12.912 16.998Z",
    fill: "#00A1ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.456 2.45398C15.6033 2.45398 14.912 3.14525 14.912 3.99798C14.912 4.85071 15.6033 5.54198 16.456 5.54198C17.3087 5.54198 18 4.85071 18 3.99798C18 3.14525 17.3087 2.45398 16.456 2.45398ZM12.912 3.99798C12.912 2.04068 14.4987 0.453979 16.456 0.453979C18.4133 0.453979 20 2.04068 20 3.99798C20 5.95528 18.4133 7.54198 16.456 7.54198C14.4987 7.54198 12.912 5.95528 12.912 3.99798Z",
    fill: "#00A1ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.544 15C2.69127 15 2 15.6913 2 16.544C2 17.3967 2.69127 18.088 3.544 18.088C4.39673 18.088 5.088 17.3967 5.088 16.544C5.088 15.6913 4.39673 15 3.544 15ZM0 16.544C0 14.5867 1.5867 13 3.544 13C5.5013 13 7.088 14.5867 7.088 16.544C7.088 18.5013 5.5013 20.088 3.544 20.088C1.5867 20.088 0 18.5013 0 16.544Z",
    fill: "#00A1ED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.544 2C2.69127 2 2 2.69127 2 3.544C2 4.39673 2.69127 5.088 3.544 5.088C4.39673 5.088 5.088 4.39673 5.088 3.544C5.088 2.69127 4.39673 2 3.544 2ZM0 3.544C0 1.5867 1.5867 0 3.544 0C5.5013 0 7.088 1.5867 7.088 3.544C7.088 5.5013 5.5013 7.088 3.544 7.088C1.5867 7.088 0 5.5013 0 3.544Z",
    fill: "#00A1ED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.78407 16.6454C5.88271 16.102 6.40319 15.7415 6.9466 15.8401L13.6786 17.0621C14.222 17.1607 14.5826 17.6812 14.4839 18.2246C14.3853 18.768 13.8648 19.1286 13.3214 19.0299L6.58939 17.8079C6.04599 17.7093 5.68543 17.1888 5.78407 16.6454Z",
    fill: "#00A1ED"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.34342 5.48035C3.88334 5.59655 4.22684 6.12844 4.11064 6.66836L2.47764 14.2564C2.36145 14.7963 1.82956 15.1398 1.28963 15.0236C0.74971 14.9074 0.406211 14.3755 0.522407 13.8356L2.15541 6.24758C2.2716 5.70766 2.80349 5.36416 3.34342 5.48035Z",
    fill: "#00A1ED"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6879 6.06384C18.2304 6.16762 18.586 6.69149 18.4822 7.23394L17.1152 14.3789C17.0114 14.9214 16.4875 15.277 15.9451 15.1732C15.4026 15.0694 15.047 14.5456 15.1508 14.0031L16.5178 6.85811C16.6216 6.31566 17.1455 5.96005 17.6879 6.06384Z",
    fill: "#00A1ED"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.53077 1.79983C5.66673 1.26455 6.21089 0.940829 6.74618 1.07679L13.7462 2.85479C14.2815 2.99076 14.6052 3.53491 14.4692 4.0702C14.3333 4.60549 13.7891 4.9292 13.2538 4.79324L6.25381 3.01524C5.71852 2.87928 5.39481 2.33512 5.53077 1.79983Z",
    fill: "#00A1ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateStructure);
export default __webpack_public_path__ + "static/media/create_structure.c295bf8d22c78bfd839b01687fb60b64.svg";
export { ForwardRef as ReactComponent };